import React from "react";
import {
  getOutletTypeFromCookies,
} from "../../../../../utils/Auth";
import FoodInventory from "./FoodInventory";
import MerchandiseInventory from "./MerchandiseInventory";

export default function InventoryManagement() {
  const outlet_type = getOutletTypeFromCookies();
  return (
    <>
      {outlet_type === "restaurant" && <FoodInventory />}
      {outlet_type === "store" && <MerchandiseInventory />}
    </>
  );
}
